import { createApp, h } from 'vue'
import ConfirmDialog from '@/views/components/ConfirmDialog.vue'

export function useConfirm() {
  const confirm = (message, options = {}) => {
    return new Promise((resolve) => {
      const container = document.createElement('div')
      document.body.appendChild(container)

      const app = createApp({
        render() {
          return h(ConfirmDialog, {
            message,
            confirmText: options.confirmText || 'OK',
            cancelText: options.cancelText || 'Cancel',
            onConfirm: () => {
              app.unmount()
              document.body.removeChild(container)
              resolve(true)
            },
            onCancel: () => {
              app.unmount()
              document.body.removeChild(container)
              resolve(false)
            },
            onClose: () => {
              app.unmount()
              if (container.parentNode) {
                document.body.removeChild(container)
              }
            }
          })
        }
      })

      app.mount(container)
    })
  }

  return {
    confirm
  }
}
